import { useContext } from 'react';
import { DynamicPreloaders } from 'core/common/components/DynamicPreloaders';
import { screenComponents } from 'core/common/components/FlowScreens/screenComponents';
import SupportBotButton from 'core/common/components/SupportBotButton';
import { useLogger } from 'core/common/hooks';
import { QuizContext } from 'core/funnel/contexts';

type FlowScreensProps = {
  pageId: string;
};

const FlowScreens = ({ pageId }: FlowScreensProps) => {
  const logger = useLogger();
  const { flowInitialScreenId, getScreenAttributes } = useContext(QuizContext);

  const screenAttributes = getScreenAttributes(pageId);

  if (!screenAttributes) return null;

  const nextScreenAttributes = screenAttributes.next
    ? getScreenAttributes(screenAttributes.next)
    : null;

  const getScreen = () => {
    const { screenType } = screenAttributes;

    if (!screenComponents[screenType]) {
      logger.error(new TypeError(`Unknown step data: ${JSON.stringify(screenType)}`));
      return null;
    }
    const { Screen } = screenComponents[screenType];

    return <Screen id={pageId} />;
  };

  return (
    <>
      {getScreen()}
      <DynamicPreloaders
        screenId={pageId}
        initialScreenId={flowInitialScreenId}
        screenAttributes={screenAttributes}
        nextScreenAttributes={nextScreenAttributes}
      />
      {screenAttributes.supportWidget && (
        <SupportBotButton variant="fixed" buttonText={screenAttributes.supportWidget.text} />
      )}
    </>
  );
};

export default FlowScreens;
